
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import { createSimpleTransition } from 'vuetify/lib/components/transitions/createTransition'
import 'material-design-icons-iconfont/dist/material-design-icons.css';
// import '@mdi/font/css/materialdesignicons.css'
// import '@fortawesome/fontawesome-free/css/all.css';

const realFade: any = createSimpleTransition('realfade')

Vue.use(Vuetify);
Vue.component('realfade', realFade);

// const VBtn = Vue.component('VBtn');
// (VBtn as any).options.props.ripple.default = false;

export default new Vuetify({
	icons: {
		iconfont: 'md',
		values: {
			'tb-icon-unchecked': 'tb-icon-unchecked',
			'tb-icon-checked': 'tb-icon-checked'
		}
	},
	// icons: {
	// 	iconfont: 'fa',
	// 	values: MY_ICONS
	// },
	theme: {
		options: {
			customProperties: true,
		},
		themes: {
			light: {
				primary: '#1a1a1a',
				secondary: '#EB0A1E',
				accent: '#82B1FF',
				error: '#d1091b',
				// info: '#2196F3',
				success: '#00c483',
				// warning: '#FFC107'
			}
		},
	},
});
